import { ReactNode } from "react";
import { Css } from "src/Css";

/** Props */
interface PageContentProps<X> {
  children: ReactNode; // Children are required
  xss?: X;
}

/**
 * Component - Page Content
 *
 * Helper component to handle duplicate layout code for page content.
 */
export function PageContent<X>({ children, xss }: PageContentProps<X>) {
  return (
    <div
      css={{
        ...Css.gc("1 / -1").ifMd.gc("2 / -2").ifLgAndUp.gc("3 / -3").$,
        ...xss,
      }}
    >
      {children}
    </div>
  );
}
